import { render, staticRenderFns } from "./DocumentSectionTree.vue?vue&type=template&id=63f09426&"
import script from "./DocumentSectionTree.vue?vue&type=script&lang=js&"
export * from "./DocumentSectionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports